import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import { sellerContext, validateSellerAuthorization } from '../../services/User';
import { logout} from '../../services/fetch';

import { setAuthState } from '../../store/actions/actions';
import { loginWithToken } from '../../services/fetch';
import { getProfile } from '../../services/Seller';
import { setSellerProfileCompleted } from '../../store/actions/seller';

class OneTimeLoginContainer extends Component {

    loginUserWithToken = async (token, queryParams) => {
        const res = await loginWithToken({token: token});
        if (res.resStatus >= 400) {
            this.setState({ errorMsg: res.message || 'Error while login.' });
            this.props.setAuthState(false, {}, '');
            this.props.history.push('/');
        }
        if (res.resStatus == 200) {
            const authRes = await validateSellerAuthorization(true);
            if (authRes.resStatus >= 400) {
                this.setState({ errorMsg: authRes.message || 'Error while login.' })
                this.props.setAuthState(false, {}, '');
                this.props.history.push('/');
            }
            else if (authRes.resStatus == 200){
                this.props.setAuthState(true, authRes.data.user, '');
                const isSeller = authRes.data.user?.Seller ? true : false;
                if(isSeller) {
                    const profileResponse = await getProfile();
                    if(profileResponse.resStatus === 200){
                        const profile = profileResponse.data;
                        
                        if(!profile.isProfileCompleted){    
                            this.props.history.push('/complete-profile');
                            return;
                        }
                    }
                    this.props.setSellerProfileCompleted(true);
                }
                    console.log(queryParams);
                    if(queryParams.originalUrl)
                    {
                        console.log(queryParams.originalUrl);
                        //window.location.href = '/requests/temp/abc/details'
                        window.location.href = queryParams.originalUrl;
                    }else
                    {
                        //window.location.href = '/requests/temp/abc/details'
                        window.location.href = '/';
                    }
            }
        }
    }


    async componentDidMount() {
        const queryParams = queryString.parse(this.props.location.search);       
        await logout(false);
        await this.loginUserWithToken(this.props.match.params.token, queryParams);
    }
    render() {    
        return (
            <div>
                
            </div>
        )
    }
}

function mapStateToProps({ auth, reducer, appView, seller }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        homeScreenLoading: reducer.homeScreenLoading,
        showSidebar: appView.showSidebar,
        seller: seller
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState,
        setSellerProfileCompleted: setSellerProfileCompleted
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(OneTimeLoginContainer);



